import { React, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import { BASE_URL } from '../config/constants';
const Login = () => {
	const navigate = useNavigate();

	const [login, setLogin] = useState({
		email: '',
		password: '',
	});

	const [message, setMessage] = useState('');
	const [isLoading, setIsLoading] = useState(false);
	const baseUrl = BASE_URL;
	const handleLogin = async (e) => {
		e.preventDefault();

		setIsLoading(true);

		try {
			const response = await fetch(`${baseUrl}/api/v1/auth/email/login`, {
				method: 'POST',
				body: JSON.stringify({ ...login }),
				headers: { 'Content-Type': 'application/json' },
			});

			const data = await response.json();

			if (response.ok) {
				Cookies.set('token', data.token, { expires: 1, path: '/' });
				localStorage.setItem('userData', JSON.stringify(data.user));
				setMessage('login successfully');
				setTimeout(() => {
					navigate('/');
				}, 1000);
			} else {
				setMessage(data.errors[Object.keys(data.errors)]);
			}
		} catch (error) {
			console.log(error);
			setMessage('Server error. Please try again later.');
			setIsLoading(false);
		} finally {
			setIsLoading(false);
		}
	};

	return (
		<div className='bg-white'>
			<section className='bg-main h-[40vh] md:h-[50vh] flex justify-center items-center mb-16'>
				<h2 className='text-2xl md:text-5xl text-white font-semibold'>Login</h2>
			</section>
			<div className='container mb-16 md:w-5/12'>
				<form
					className='bg-[#f2f3f5] flex flex-col gap-4 p-6 md:p-6 items-center rounded'
					onSubmit={handleLogin}>
					<div className='input-group w-full'>
						<input
							className='w-full outline-none p-3 rounded border-[#cedbea] border-[1px] border-solid'
							type='email'
							required
							placeholder='Email'
							value={login.email}
							onChange={(e) => setLogin({ ...login, email: e.target.value })}
						/>
					</div>
					<div className='input-group w-full'>
						<input
							className='w-full outline-none p-3 rounded border-[#cedbea] border-[1px] border-solid'
							type='password'
							required
							placeholder='Password'
							value={login.password}
							onChange={(e) => setLogin({ ...login, password: e.target.value })}
						/>
					</div>
					<div className='input-group w-full'>
						<button
							type='submit'
							disabled={isLoading}
							className={`text-center w-full p-3 rounded text-main font-bold ${
								isLoading ? 'bg-gray-400' : 'bg-secondary'
							}`}>
							{isLoading ? 'Loading...' : 'Login'}
						</button>
					</div>
					{message && (
						<p
							className={`text-sm ${
								message.includes('successfully')
									? 'text-green-600'
									: 'text-red-700'
							}`}>
							{message}
						</p>
					)}

					<Link
						to='/reset-password'
						className='self-start text-textColor transition-all duration-300 md:hover:text-secondary md:hover:underline'>
						Forget Password
					</Link>
					<div className='self-start text-textColor'>
						<Link
							to='/signup'
							className='font-bold md:hover:text-secondary transition-all duration-300 text-xl'>
							SignUp
						</Link>
					</div>
				</form>
			</div>
		</div>
	);
};

export default Login;
